"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const ConsoleLogger_1 = require("./ConsoleLogger");
const LambdaLogger_1 = require("./LambdaLogger");
const LoggerLevels_1 = require("./LoggerLevels");
class Logger {
    static setLogLevel(level) {
        this.logLevel = level;
        if (this.logger) {
            this.logger.setLevel(this.logLevel);
        }
    }
    static getLogLevel() {
        return this.logLevel;
    }
    static instance() {
        if (!this.logger) {
            if (process.env.IS_OFFLINE) {
                this.logger = new ConsoleLogger_1.ConsoleLogger(this.logLevel);
            }
            else {
                this.logger = new LambdaLogger_1.LambdaLogger(this.logLevel);
            }
        }
        return this.logger;
    }
    static error(message, ...optionalParams) {
        if (this.logLevel === LoggerLevels_1.LoggerLevels.Silent) {
            return;
        }
        this.instance().error(message, ...optionalParams);
    }
    static warn(message, ...optionalParams) {
        if (this.logLevel === LoggerLevels_1.LoggerLevels.Silent) {
            return;
        }
        this.instance().warn(message, ...optionalParams);
    }
    static info(message, ...optionalParams) {
        if (this.logLevel === LoggerLevels_1.LoggerLevels.Silent) {
            return;
        }
        this.instance().info(message, ...optionalParams);
    }
    static debug(message, ...optionalParams) {
        if (this.logLevel === LoggerLevels_1.LoggerLevels.Silent) {
            return;
        }
        this.instance().debug(message, ...optionalParams);
    }
    static verbose(message, ...optionalParams) {
        if (this.logLevel === LoggerLevels_1.LoggerLevels.Silent) {
            return;
        }
        this.instance().verbose(message, ...optionalParams);
    }
    static silly(message, ...optionalParams) {
        if (this.logLevel === LoggerLevels_1.LoggerLevels.Silent) {
            return;
        }
        this.instance().silly(message, ...optionalParams);
    }
}
exports.Logger = Logger;
Logger.logLevel = process.env.LOG_LEVEL ?? LoggerLevels_1.LoggerLevels.Debug;
//# sourceMappingURL=Logger.js.map